import { Modals } from '@/constants';

import { AppModal } from '../AppModal';
import { EpisodeFeedbackModalContent } from './EpisodeFeedbackModalContent.container';

export const EpisodeFeedbackModal = () => {
  return (
    <AppModal
      modalName={Modals.EPISODE_FEEDBACK}
      scroll="paper"
      transparentBackground
      maxWidth={false}>
      <EpisodeFeedbackModalContent />
    </AppModal>
  );
};
